export default __webpack_public_path__ + "static/media/img12.78c75f8c.png";